const SETTLEMENT_STATUS = {
  PENDING_CALCULATION: 0,
  ALREADY_SETTLED: 1,
  CLOSED: 2,
}
export const config = function (configData) {
  const {
    offlineSettlement,
  } = configData
  const tableColumns = [
    {
      name: 'settlementDate',
      columnProps: {
        prop: 'settlementDate',
        label: '结算日期',
        width: 120,
      },
    },
    {
      name: 'settlementCycle',
      columnProps: {
        prop: 'settlementCycle',
        label: '结算周期',
        width: 220,
      },
      render: ({ row }) => {
        return `${row.settlementCycleStart} 至 ${row.settlementCycleEnd}`
      },
    },
    {
      name: 'withholdAmount',
      columnProps: {
        prop: 'withholdAmount',
        label: '网约钱包支付总金额',
        width: 160,
      },
    },
    {
      name: 'planSettlementAmount',
      columnProps: {
        prop: 'planSettlementAmount',
        label: '应结算金额',
        width: 120,
      },
    },
    {
      name: 'settledAmount',
      columnProps: {
        prop: 'settledAmount',
        label: '已结算金额',
        width: 120,
      },
    },
    {
      name: 'pendingSettlementAmount',
      columnProps: {
        prop: 'pendingSettlementAmount',
        label: '待结算金额',
        width: 120,
      },
    },
    {
      name: 'paymentGenerateDate',
      columnProps: {
        prop: 'paymentGenerateDate',
        label: '生成时间',
        width: 120,
      },
    },
    {
      name: 'actualSettlementDate',
      columnProps: {
        prop: 'actualSettlementDate',
        label: '结算时间',
        width: 120,
      },
    },
    {
      name: 'state',
      columnProps: {
        prop: 'state',
        label: '状态',
      },
      render: ({ row }) => {
        const statusMap = {
          [SETTLEMENT_STATUS.PENDING_CALCULATION]: {
            label: '待结算',
            type: 'warning',
          },
          [SETTLEMENT_STATUS.ALREADY_SETTLED]: {
            label: '已结算',
            type: 'success',
          },
          [SETTLEMENT_STATUS.CLOSED]: {
            label: '已关闭',
            type: 'info',
          },
        }
        const status = statusMap[row.state] || { type: '', label: '--' }
        return <el-tag type={status.type}>{status.label}</el-tag>
      },
    },
    {
      name: 'operate',
      columnProps: {
        label: '操作',
        width: 240,
        fixed: 'right',
      },
      type: 'operate',
      getOperateList: ({ row }) => {
        if (row.state === SETTLEMENT_STATUS.PENDING_CALCULATION) {
          return [{
            name: 'settlement',
            label: '线下结算',
            action: () => offlineSettlement(row),
          }]
        }
        return []
      },
    },
  ]
  return {
    tableColumns,
  }
}
